export const memberType = [
    {
      id: 1,
      title: "高校师生",
    },
    {
      id: 2,
      title: "科研单位",
    },
    {
      id: 3,
      title: "校长教师",
    },
    {
      id: 4,
      title: "特约稿件",
    },
    {
      id: 0,
      title: "其他",
    },
  ];

// 0：自由投稿 1：集体投稿 2：理事单位投稿 3：基地学校投稿
export const solicitType = [
	{
	  id: 0,
	  title: "自由投稿",
	},
	{
	  id: 1,
	  title: "集体投稿",
	},
	{
	  id: 2,
	  title: "理事单位投稿",
	},
	{
	  id: 3,
	  title: "基地学校投稿",
	}
]